import ElevatorTypology from './components/ElevatorTypology/ElevatorTypology';
import GarageTypology from './components/GarageTypology/GarageTypology';
import ValidationGoodZone from './components/ValidationGoodZone/ValidationGoodZone';
import ValidationHistoricalBusinessInformation from './components/ValidationHistoricalBusinessInformation/ValidationHistoricalBusinessInformation';
import ValidationRoomsBathrooms from './components/ValidationRoomsBathrooms/ValidationRoomsBathrooms';
const country = localStorage.getItem('country');

const ValidationsTab = () => {
  return (
    <div>
      <ValidationGoodZone />
      {country === 'CO' && <ValidationRoomsBathrooms />}
      <ValidationHistoricalBusinessInformation />
      {country === 'CO' && <ElevatorTypology />}
      <GarageTypology />
    </div>
  );
};

export default ValidationsTab;
